// extracted by mini-css-extract-plugin
export default {"productGallery":"bM-z","inQuickShop":"cM-z"};